module.exports = __webpack_public_path__ + "static/media/video.be6f1eb1.mp4";